export default "__VITE_ASSET__DkYzISqU__"